declare var Stripe;

export const environment = {
  production: true,
  /*base: 'https://www.grassrootslabs.com/api',
  baseImageUrl: 'https://www.grassrootslabs.com/api/api/image/',
  baseIconUrl: 'https://www.grassrootslabs.com/api/api/image/thumb/',*/

  blogUrl: 'https://www.grassrootslabs.com/blog',
  // blogUrl: 'https://info.grassrootslabs.com/grassroots-labs-blog-temporarily-under-construction',
  covidIdList: ['d88e56be-a590-4b45-b188-aba40147a2f7'],
  covidWithoutThreeSteps: [
    '3fd0ba50-27e9-4eb5-af33-abdb00e30720',
    '2a2a630a-37ba-4c36-a885-abde014a350c',
    // prod ids
    'dba5e6a5-1203-4637-b653-abce00fb6764',
    'a56e414d-2db6-447c-8b63-abde0149d001'
  ],
  covidIdListEmp: [
    // '3fd0ba50-27e9-4eb5-af33-abdb00e30720',
    'abba89b7-f5ef-4cc4-9176-abde0148f00d',
    // '2a2a630a-37ba-4c36-a885-abde014a350c',
    // prod ids
    // 'dba5e6a5-1203-4637-b653-abce00fb6764',
    'e8cdb352-a145-43b3-bd1a-abce00fc15d4',
    // 'a56e414d-2db6-447c-8b63-abde0149d001'
  ],

  stripeTest : 'pk_live_U3B61qiha1qqsHDu9m9UsDQb',
  
  compressedData: 'compressedData123',

  questCodesSaliva: ['12345', '8138'],
  questCodesEmpWithoutThreeSteps: ['p1598', 'p1599'],
  // questCodesEmp: ['p1598', 'p1599', '39448'],
  questCodesEmp: ['39448'],
  questCodes: ['39504'],
  base: 'https://www.grassrootslabs.com/api',
  baseUrl: 'https://www.grassrootslabs.com',
  baseImageUrl: 'https://www.grassrootslabs.com/api/api/image/',
  baseIconUrl: 'https://www.grassrootslabs.com/api/api/image/thumb/',
  processingFee: 28,
  physicianFee: 6,
  labDrawFee: 4,
  carouselInterval: 9000,
  version: ''
};
